export const API_DIRECTORY = { DOC_ROOT: '' }

export const urlConstants = {
  BASE_URL: process.env.REACT_APP_ENV_URL,
}

export const API_INTERFACE = {
  // FIND_MEMBER: '/findMember',
  FIND_MEMBER: '/getMembers',
  GET_MEMBER_DETAIL: '/getMemberDetail',
  GET_SPECIALTY_LIST: '/getSpecialties',
  // GET_SPECIALTY_LIST: '/getSpecialtyList',
  // GET_AREA_OF_FOCUS: '/getAreaOfFocus',
  // GET_LOCATION: '/getLocation',
  // FIND_PROVIDERS: '/findProviders',
  FIND_PROVIDERS: '/getProviders',
  // GET_MANAGEMENT_REFERRAL_LIST: '/getReferrals',
  GET_MANAGEMENT_REFERRAL_LIST: '/getReferralsOpenSearch',
  EXTEND_REFERRAL: '/extendReferral',
  SUBMIT_REFERRAL_PROVIDER: '/submitReferral',
  PROVIDER_DETAILS: '/getProviderDetail',
  // SIGN_IN_USER: '/signInUser',
  SIGN_IN_USER: '/login',
  SSO_LOGIN: '/ssoLogin',
  GET_USER: '/getUser',
  GET_PLAN_DETAIL: '/getPlanDetail',
  FORGET_PASSWORD: '/forgotPassword',
  SEND_ACCESS_CODE: '/sendAccessCode',
  GET_MEDICAL_NEIGHBORHOOD: '/getMedicalNeighborhood',
  GET_ASSIGNED_MEMBERS: '/getAssignedMembers',
  GET_CLIENT_LIST: '/getClientList',
  GET_MEMBERS_BY_TIN: '/getMembersByPcpTin',
  GET_REFERRAL_MEMBER: '/getReferralMember',
}

export const uriConstants = {
  FIND_MEMBER_API: urlConstants.BASE_URL + API_INTERFACE.FIND_MEMBER,
  GET_MEMBER_DETAIL_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_MEMBER_DETAIL,
  GET_SPECIALTY_LIST_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_SPECIALTY_LIST,
  GET_AREA_OF_FOCUS_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_AREA_OF_FOCUS,
  GET_LOCATION_API: urlConstants.BASE_URL + API_INTERFACE.GET_LOCATION,
  FIND_PROVIDERS_API: urlConstants.BASE_URL + API_INTERFACE.FIND_PROVIDERS,
  GET_MANAGEMENT_REFERRAL_LIST_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_MANAGEMENT_REFERRAL_LIST,
  EXTEND_REFERRAL_API: urlConstants.BASE_URL + API_INTERFACE.EXTEND_REFERRAL,
  SUBMIT_REFERRAL_PROVIDER_API:
    urlConstants.BASE_URL + API_INTERFACE.SUBMIT_REFERRAL_PROVIDER,
  GET_PROVIDER_DETAIL: urlConstants.BASE_URL + API_INTERFACE.PROVIDER_DETAILS,
  GET_SIGN_IN_USER: urlConstants.BASE_URL + API_INTERFACE.SIGN_IN_USER,
  SSO_LOGIN: urlConstants.BASE_URL + API_INTERFACE.SSO_LOGIN,
  GET_PLAN_DETAIL: urlConstants.BASE_URL + API_INTERFACE.GET_PLAN_DETAIL,
  FORGET_PASSWORD: urlConstants.BASE_URL + API_INTERFACE.FORGET_PASSWORD,
  SEND_ACCESS_CODE: urlConstants.BASE_URL + API_INTERFACE.SEND_ACCESS_CODE,
  GET_MEDICAL_NEIGHBORHOOD:
    urlConstants.BASE_URL + API_INTERFACE.GET_MEDICAL_NEIGHBORHOOD,
  GET_USER: urlConstants.BASE_URL + API_INTERFACE.GET_USER,
  GET_ASSIGNED_MEMBERS_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_ASSIGNED_MEMBERS,
  GET_MEMBERS_BY_TIN_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_MEMBERS_BY_TIN,
  GET_CLIENT_LIST: urlConstants.BASE_URL + API_INTERFACE.GET_CLIENT_LIST,
  GET_GMAP_KEY: `${urlConstants.BASE_URL}/getGMapKey`,
  GET_S3_SELECT: `${urlConstants.BASE_URL}/getS3Select`,
  GET_REFERRAL_MEMBER_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_REFERRAL_MEMBER,
}
